const JSONValidatorMockData = {
  call: [
    {
      connection: 'REST-Feed',
      url: 'https://cloud.feedly.com/v3/subscriptions',
      httpMethod: 'GET',
      httpContentType: 'application/json',
      userResponsePath: '',
      httpHeaders: {
        Authorization: '${access_token}'
      },
      colsToPropsMap: {
        username: 'id~#~char',
        displayname: 'title~#~char'
      }
    }
  ]
};
export default JSONValidatorMockData;
